import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const article = () => {
	const progress = () => {
		const bar = document.querySelector('.article-progress__bar span')
		const banner = document.querySelector('.article-banner')
		const article = document.querySelector('.article')

		if (!article) return

		gsap.to(bar, {
			scrollTrigger: {
				trigger: banner,
				endTrigger: article,
				start: 'top top',
				end: 'bottom bottom',
				scrub: true
			},
			width: '100%'
		})
	}

	const nav = () => {
		const article = document.querySelector('.article')
		const anchors = document.querySelectorAll('.article__anchor')
		const links = document.querySelectorAll('.article__sidebar a')

		if (!anchors.length) return

		anchors.forEach((anchor, i) => {
			ScrollTrigger.create({
				trigger: anchor,
				start: 'top 35%',
				endTrigger: anchors[i + 1] ? anchors[i + 1] : article,
				end: anchors[i + 1] ? 'top 35%' : 'bottom 35%',
				onToggle: (self) => {
					if (self.isActive) {
						links[i].classList.add('active')
					} else {
						links[i].classList.remove('active')
					}
				}
			})
		})
	}

	progress()
	nav()
}

export default () => {}
